var map = {
	"./BAT.png": 896,
	"./COMP.png": 417,
	"./DAI.png": 897,
	"./ETH.png": 898,
	"./LINK.png": 899,
	"./TUSD.png": 900,
	"./UNI.png": 901,
	"./USDC.png": 902,
	"./USDT.png": 903,
	"./WBTC legacy.png": 904,
	"./WBTC.png": 905,
	"./ZRX.png": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 501;